import { CheckIcon } from "@heroicons/react/24/outline";

/**
 * Case Form Fields/Checkbox input : 20px, rayon 4, bordure 1.
 * Repos blanc / gray-300, coché blue-chronoflex-600.
 * Focus, coché ou non : anneau #138BFF (spread 4) et décalage blanc (spread 2).
 */
export default function Checkbox({
  checked,
  onChange,
  disabled = false
}: {
  checked: boolean,
  onChange: (checked: boolean) => void,
  disabled?: boolean
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`inline-flex h-5 w-5 shrink-0 items-center justify-center rounded border
        focus:outline-none focus:ring-2 focus:ring-[#138BFF] focus:ring-offset-2 focus:ring-offset-white
        disabled:cursor-not-allowed disabled:opacity-50
        ${checked ? "!border-[#1B7AF5] !bg-[#1B7AF5] !text-white" : "border-[#B6BAC3] bg-white text-transparent"}`}
    >
      <CheckIcon className="h-3.5 w-3.5" strokeWidth={2.5} />
    </button>
  );
}
